import { render } from "./ResizeHandler.vue?vue&type=template&id=c9559332&scoped=true&ts=true"
import script from "./ResizeHandler.vue?vue&type=script&lang=ts"
export * from "./ResizeHandler.vue?vue&type=script&lang=ts"

import "./ResizeHandler.vue?vue&type=style&index=0&id=c9559332&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9559332"]])

export default __exports__